export const ReservationsTableColumns = [
  { key: "id", label: "Reservation ID" },
  { key: "reservationDate", label: "Reservation Date" },
  { key: "timeSlot", label: "Time Slot" },
  { key: "fullName", label: "Full Name" },
  { key: "contactNum", label: "Contact Number" },
  { key: "pax", label: "Pax" },
  { key: "status", label: "Status" },
];
